export const API_URL = getAPIURL();
//export const PAYMENT_GATEWAY_SUCCESS_URL="http://localhost:8097/paygateresponse";
//export const PAYMENT_GATEWAY_SUCCESS_URL="https://payuat.easetolearn.com/app/paygateresponse";
export const PAYMENT_GATEWAY_SUCCESS_URL =
  "https://payment.easetolearn.com/app/paygateresponse"; //for razorpay add /razorpay as postfix
export const LIVE_CLASS_URL = "https://live.easetolearn.com";
//export const WEB_URL_COURSE="student.easetolearn.com";
// export const WEB_PANEL_URL = "http://localhost:3001/student";
export const WEB_PANEL_URL = "https://easetolearn.com/student";
export const WHITE_LABEL_LOGO_URL =
  "https://cdn.easetolearn.com/organisations/logos";
// export const STUDENT_URL = "http://localhost:3001/student";
export const STUDENT_URL = "https://easetolearn.com/student";

export const getWebPanelUrl = () => {
  let url;
  switch(window.location.host) {
    case 'easetolearn.com':
        url = 'https://userapi.easetolearn.com';
        break;
    case 'www.easetolearn.com':
        url = 'https://userapi.easetolearn.com';
        break;
    case 'student.easetolearn.com':
        url = 'https://userapi.easetolearn.com';
        break;
    case 'www.student.easetolearn.com':
        url = 'https://userapi.easetolearn.com';
        break;  
    case 'dev.easetolearn.com':
        url = 'https://userapiuat.easetolearn.com';
        break;
    case 'devuat.easetolearn.com':
        url = 'https://userapiuat.easetolearn.com';
        break;      
    case 'uat.easetolearn.com':
        url = 'https://userapiuat.easetolearn.com';
        break;
    case 'saket.easetolearn.com':
        url = 'https://userapi.easetolearn.com';
        break; 
    case 'localhost:3000':
          // url = 'http://localhost:8098';
          url = 'https://userapi.easetolearn.com';
          //url = 'https://userapiuat.easetolearn.com';
          break;     
    case 'localhost:3001':
        url = 'http://localhost:8098';
        // url = 'https://userapi.easetolearn.com';
        //url = 'https://userapiuat.easetolearn.com';
        break;  
    default:
      url = "https://easetolearn.com/student";
  }
  return url;
};

function getAPIURL() {
  let url;
  switch (window.location.host) {
    case "easetolearn.com":
      url = "https://userapi.easetolearn.com";
      break;
    case "www.easetolearn.com":
      url = "https://userapi.easetolearn.com";
      break;
    case "student.easetolearn.com":
      url = "https://userapi.easetolearn.com";
      break;
    case "www.student.easetolearn.com":
      url = "https://userapi.easetolearn.com";
      break;
    case "dev.easetolearn.com":
      url = "https://userapi.easetolearn.com";
      break;
    case "devuat.easetolearn.com":
      url = "https://userapi.easetolearn.com";
      break;
    case "uat.easetolearn.com":
      url = "https://userapiuat.easetolearn.com";
      break;
    case "localhost:3000":
        url = 'http://localhost:8098';
        //url = "https://userapiuat.easetolearn.com";
        //url = "https://userapi.easetolearn.com";
        break;  
    case "localhost:3001":
      url = 'http://localhost:8098';
      //url = "https://userapiuat.easetolearn.com";
      //url = "https://userapi.easetolearn.com";
      break;
    default:
      url = "https://userapi.easetolearn.com";
    //url = 'https://studentapi.easetolearn.com';
    //url = 'https://studentapiuat.easetolearn.com';
  }
  return url;
}
